<template>
	<EMCoreTemplate category="OSMLife" identity="investmentStrategy" entity="osm_investment_strategy"></EMCoreTemplate>
</template>
<script type="text/javascript">
	import {EMCoreTemplate} from '@/Adm/components' 
	export default{
		components:{
			EMCoreTemplate
		}	
	}

</script>


// WEBPACK FOOTER //
// src/Adm/EntityManagementLife/containers/InvestmentStrategy.vue